import type { RefObject } from 'react';

import type { WhatsappTemplate } from '../../../pages/settings/whatsapp/useWhatsappTemplate';

import Button from '../Button';
import Text from '../Text';
import { t } from '../../i18n/langue';
import { apercu } from './helpers';

/**
 * L'étape de relecture avant envoi — extrait de #19, audit 2026-09-23.
 *
 * Un modèle part payant et sans retour. On le relit EN ENTIER avant de l'envoyer ;
 * l'aperçu de la liste est tronqué à deux lignes, celui-ci ne l'est pas.
 */
interface EtapeVerificationModeleProps {
    modele: WhatsappTemplate;
    titreRef: RefObject<HTMLHeadingElement>;
    onEnvoyer: () => void;
    onChoisirAutre: () => void;
}

export default function EtapeVerificationModele({
    modele,
    titreRef,
    onEnvoyer,
    onChoisirAutre,
}: EtapeVerificationModeleProps) {
    return (
        <>
            <h2 ref={titreRef} tabIndex={-1} className="mb-2 outline-none">
                <Text variante="sousTitre" as="span">
                    {t('composeur.modeles.verifiez')}
                </Text>
            </h2>
            {/* Le texte BRUT : `apercu()` écrase les sauts de ligne. */}
            <p
                data-testid="texte-modele"
                className="whitespace-pre-wrap rounded-xl bg-main-bg-color p-3 text-base text-text-color"
            >
                {modele.text || apercu(modele)}
            </p>
            <div className="mt-4 flex flex-col gap-2">
                <Button libelle={t('composeur.modeles.envoyer')} pleineLargeur onPress={onEnvoyer} />
                <Button libelle={t('composeur.modeles.choisirAutre')} variante="discret" pleineLargeur onPress={onChoisirAutre} />
            </div>
        </>
    );
}
